export default __webpack_public_path__ + "static/media/exhibition-01.0e428395.jpg";